import { Button } from "../Button";
import "./TooltipCard.scss";
import cx from "classnames";

type TooltipCardProps = {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
  value?: string;
  onClose?: () => void;
  closeButtonSize?: "lg" | "md" | "sm" | "xs";
};

const TooltipCard = ({
  children,
  className,
  style,
  title,
  value,
  onClose,
  closeButtonSize = "xs",
}: TooltipCardProps) => {
  return (
    <div className={cx("TooltipCard", className)} style={style}>
      {onClose && (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          size={closeButtonSize}
          variant="inverse"
          iconName="X"
          iconPosition="left"
          className="TooltipCard__Close"
        />
      )}
      {title && <span className="TooltipCard__Title">{title}</span>}
      {value && <span className="TooltipCard__Value">{value}</span>}
      {children}
    </div>
  );
};

export { TooltipCard };
